import classNames from 'clsx';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import sharedCss from 'src/common/components/containerItems/shared/guide-item.module.scss';
import { DiscordGeoRestrictionsTileAreaTooltip } from 'src/common/components/discord/DiscordGeoRestrictionsTooltip';
import ImageWithDefault from 'src/common/components/shared/ImageWithDefault';
import { selectIsFord } from 'src/common/selectors/app';
import assetUrl from 'src/common/utils/assetUrl';
import { isDiscordMode } from 'src/common/utils/discord';
import css from './profile-logo.module.scss';

const ProfileLogo = (props) => {
  const {
    image,
    title,
    hasPremiumBadge,
    hasBoostBadge,
    containerClassName,
    imageWrapperClassName,
    guideItem,
  } = props;
  const isFord = useSelector(selectIsFord);

  const applyBadge = (url, alt) => (
    <img className={sharedCss.badgeImage} src={assetUrl(url)} alt={alt} />
  );

  return (
    <div className={classNames(containerClassName, css.logoContainer)}>
      {!isFord && hasPremiumBadge && applyBadge('assets/img/shared/premium-badge.svg')}
      {/* The Discord check can be removed when PLATFORM-17505 is resolved */}
      {!hasPremiumBadge &&
        hasBoostBadge &&
        !isDiscordMode() &&
        applyBadge('assets/img/shared/boost-badge.svg')}
      <ImageWithDefault
        src={image}
        alt={`${title}-logo`}
        dataTestId="logo"
        className={css.logoImage}
        containerClassName={classNames(imageWrapperClassName, css.logoWrapper)}
      />
      {isDiscordMode() && <DiscordGeoRestrictionsTileAreaTooltip guideItem={guideItem} />}
    </div>
  );
};

ProfileLogo.propTypes = {
  image: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  containerClassName: PropTypes.string,
  imageWrapperClassName: PropTypes.string,
  hasPremiumBadge: PropTypes.bool,
  hasBoostBadge: PropTypes.bool,
};

export default ProfileLogo;
